module.exports = __webpack_public_path__ + "img/edge_activites_trotinette.9e29bc62.svg";